<mat-card appearance="outlined" class="video-player-card mat-elevation-z8">


  <mat-card-content class="video-content">
    <!-- The HTML5 video element -->
    <video #videoPlayer [src]="videoUrl" class="video-element" controls="false" controlsList="nodownload"
      (play)="isPlaying = true" (pause)="isPlaying = false"></video>

    <!-- Custom Controls for the video player -->
    <div class="video-controls">

      <!-- Rewind Button -->
      <button mat-icon-button (click)="rewind(10)" matTooltip="Rewind 10s">
        <mat-icon>replay_10</mat-icon>
      </button>

      <!-- Play/Pause Button -->
      <button mat-fab color="white" (click)="togglePlayPause()" matTooltip="{{ isPlaying ? 'Pause' : 'Play' }}">
        <mat-icon>{{ isPlaying ? 'pause' : 'play_arrow' }}</mat-icon>
      </button>


      <!-- Fast Forward Button -->
      <button mat-icon-button (click)="fastForward(10)" matTooltip="Fast Forward 10s">
        <mat-icon>forward_10</mat-icon>
      </button>

      <!-- Replay Button -->
      <button mat-icon-button (click)="replay()" matTooltip="Replay">
        <mat-icon>replay</mat-icon>
      </button>

    </div>
  </mat-card-content>

  <mat-card-header>
    <mat-card-title class="player-title">{{ videoTitle }}</mat-card-title>
  </mat-card-header>

</mat-card>

<button mat-icon-button (click)="goBack()" class="back-btn" color="white" matTooltip="Back to List">
  <mat-icon>arrow_back</mat-icon>
</button>

<!-- //////  TIMESTAMP INDEX CARD  -->
<mat-card appearance="outlined" class="video-player-card mat-elevation-z8">

  <mat-card-header>
    <mat-card-title class="player-title">Topic Index</mat-card-title>
  </mat-card-header>

  <mat-card-content>

    <div>
      <table>
        <thead>
          <tr>
            <th>Timestamp</th>
            <th>Topic</th>
          </tr>
        </thead>
        <tbody>
          @for (topic of videoTopics; track topic) {
          <tr (click)="playTimestamp(topic.timestamp)">
            <td class="timestamp-link">{{topic.timestamp}}</td>
            <td>{{topic.topic}}</td>
          </tr>
          }

        </tbody>
      </table>

    </div>

  </mat-card-content>

</mat-card>

<!-- Back button -->
<!-- Back button -->
<button mat-icon-button (click)="goBack()" class="back-btn" color="white" matTooltip="Back to List">
  <mat-icon>arrow_back</mat-icon>
</button>